import { useEffect, useState } from "react";
import { FEATURES_LOADED_EVENT, isFeaturePermitted } from "@/utils/functions/rbac";

/**
 * Permission flag that re-evaluates when features finish loading.
 * Prefer this over `useMemo(() => isFeaturePermitted(...), [])` — memo runs once
 * before features are in storage and never updates, so gated UI stays hidden.
 */
export function useFeaturePermission(featureName: string): boolean {
    const [permitted, setPermitted] = useState(() => isFeaturePermitted(featureName));

    useEffect(() => {
        const refresh = () => setPermitted(isFeaturePermitted(featureName));
        refresh();
        window.addEventListener(FEATURES_LOADED_EVENT, refresh);
        return () => window.removeEventListener(FEATURES_LOADED_EVENT, refresh);
    }, [featureName]);

    return permitted;
}
